const sentMessageIds = new Set<string>();

export function hasBeenSent(localId: string): boolean {
  return sentMessageIds.has(localId);
}

export function markAsSent(localId: string): boolean {
  if (sentMessageIds.has(localId)) {
    return false;
  }
  sentMessageIds.add(localId);
  return true;
}

export function clearSentMessages(): void {
  sentMessageIds.clear();
}

export function getSentMessageCount(): number {
  return sentMessageIds.size;
}
